import { ExperienceType } from '@/generated/graphql';

type ExperienceStep = {
  icon?: string;
  name?: string;
};

type Experience = {
  experience?: string;
  name?: string;
  link?: string;
  detail?: string;
  video?: string;
  steps?: ExperienceStep[];
};

export const Experiences: Experience[] = [
  {
    experience: 'Curiko One-on-one experiences',
    name: 'See all One-on-one experiences',
    link: '/explore/?type=Schedule',
    detail: `Curiko One-on-one experiences enable you to meet individually with a Host to explore a passion or pursuit. You can ask questions, swap stories, and set the focus. Maybe groups aren't your thing, or you want to dive deep!`,
    video: '/discover/experiences/11.png',
    steps: [
      {
        icon: '/discover/experiences/modal/laptop.png',
        name: 'Request 1:1 experience',
      },
      {
        icon: '/discover/experiences/modal/calendar.png',
        name: 'Host confirms the time',
      },
      {
        icon: '/discover/experiences/modal/zoom.png',
        name: 'Do online experience',
      },
      {
        icon: '/discover/experiences/modal/buble.png',
        name: 'Reflect on your experience',
      },
    ],
  },
  {
    experience: 'Curiko Group experiences',
    name: 'See all Group experiences',
    link: '/explore/?type=Event',
    detail: `Curiko Group experiences are lively spaces to connect with a Host and other community members around a shared topic of interest. Hear different ideas and exchange thoughts. Groups can be great starting points to get to know the Curiko community.`,
    video: '/discover/experiences/group.png',
    steps: [
      {
        icon: '/discover/experiences/modal/laptop.png',
        name: 'Book experience',
      },
      {
        icon: '/discover/experiences/modal/zoom.png',
        name: 'Do online experience',
      },
      {
        icon: '/discover/experiences/modal/buble.png',
        name: 'Reflect on your experience',
      },
    ],
  },
  {
    experience: 'Curiko Box Experiences',
    name: 'See all Box experiences',
    link: '/explore/?type=Box',
    detail: `Curiko Box experiences come to your doorstep with all the materials you need to try something new. Take on projects at your own pace. Boxes are made with love by Hosts, and include personal recommendations to communities of interest.`,
    video: '/discover/experiences/box1.png',
    steps: [
      {
        icon: '/discover/experiences/modal/laptop.png',
        name: 'Choose a Box to order',
      },
      {
        icon: '/discover/experiences/modal/stamp.png',
        name: 'Box arrives! Check it out',
      },
      {
        icon: '/discover/experiences/modal/box.png',
        name: 'Try with the videos attached ',
      },
      {
        icon: '/discover/experiences/modal/buble.png',
        name: 'Reflect on your experience',
      },
    ],
  },
  {
    experience: 'Curiko Video Experiences',
    name: 'See all Video experiences',
    link: '/explore/?type=Video',
    detail: `Curiko Video experiences happen whenever you want. Get introduced to new subjects through the eyes of Hosts. Pause, skip, and rewatch as much as you’d like. Afterwards, follow-up with Hosts to find out more.`,
    video: '/discover/experiences/video.png',
    steps: [
      {
        icon: '/discover/experiences/modal/laptop.png',
        name: 'Choose an experience',
      },
      {
        icon: '/discover/experiences/modal/screen.png',
        name: 'Watch the video on your own pace',
      },
      {
        icon: '/discover/experiences/modal/buble.png',
        name: 'Do the stretch challenges',
      },
      {
        icon: '/discover/experiences/modal/map.png',
        name: 'Reach out to the host to find a new community!',
      },
    ],
  },
];

type ModalExperienceStep = {
  icon?: string;
  name?: string;
};

type ModalExperience = {
  mainIcon?: string;
  heading?: string;
  detail?: string;
  steps?: ModalExperienceStep[];
};

export const modalExperiences: Record<
  Exclude<ExperienceType, ExperienceType.Undefined>,
  ModalExperience
> = {
  [ExperienceType.Box]: {
    mainIcon: '/discover/experiences/mobile/box.png',
    heading: 'How do Curiko Box experiences work?',
    detail:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    steps: [
      {
        icon: '/discover/experiences/modal/laptop.png',
        name: 'Choose a Box to order',
      },
      {
        icon: '/discover/experiences/modal/stamp.png',
        name: 'Box arrives! Check it out',
      },
      {
        icon: '/discover/experiences/modal/box.png',
        name: 'Try with the videos attached ',
      },
      {
        icon: '/discover/experiences/modal/buble.png',
        name: 'Reflect on your experience',
      },
    ],
  },
  [ExperienceType.Video]: {
    mainIcon: '/discover/experiences/mobile/video.png',
    heading: 'How do video experiences work?',
    detail:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    steps: [
      {
        icon: '/discover/experiences/modal/laptop.png',
        name: 'Choose a video experience',
      },
      {
        icon: '/discover/experiences/modal/screen.png',
        name: 'Do video  experience',
      },
      {
        icon: '/discover/experiences/modal/buble.png',
        name: 'Reflect on your experience',
      },
    ],
  },
  [ExperienceType.Event]: {
    mainIcon: '/discover/experiences/mobile/group.png',
    heading: 'How do group experiences work?',
    detail:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    steps: [
      {
        icon: '/discover/experiences/modal/step.png',
        name: 'Pt. 1 of the Group Journey',
      },
      {
        icon: '/discover/experiences/modal/step1.png',
        name: 'Pt. 2 of the Group Journey',
      },
      {
        icon: '/discover/experiences/modal/step2.png',
        name: 'Pt. 3 of the Group Journey',
      },
    ],
  },
  [ExperienceType.Schedule]: {
    mainIcon: '/discover/experiences/mobile/one-on-one.png',
    heading: 'How do one-on-one experiences work?',
    detail:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    steps: [
      {
        icon: '/discover/experiences/modal/laptop.png',
        name: 'Request 1:1 experience',
      },
      {
        icon: '/discover/experiences/modal/calendar.png',
        name: 'Host confirms the time',
      },
      {
        icon: '/discover/experiences/modal/zoom.png',
        name: 'Do online experience',
      },
      {
        icon: '/discover/experiences/modal/buble.png',
        name: 'Reflect on your experience',
      },
    ],
  },
};
